export const MAX_OFFSET_IN_DAYS = 365 * 20;
